import { ShieldCheck, Wrench, Banknote, BadgeCheck } from "lucide-react";
import Reveal, { SectionHead } from "@/components/Reveal";

const POINTS = [
  {
    icon: ShieldCheck,
    title: "Reperibilità reale 24/7",
    text: "Anche di notte, nei festivi e nei weekend. Risponde una persona, non una segreteria.",
  },
  {
    icon: Wrench,
    title: "Tecnici qualificati",
    text: "Professionisti abilitati con strumentazione di diagnosi e ricambi a bordo.",
  },
  {
    icon: Banknote,
    title: "Prezzi trasparenti",
    text: "Il costo è comunicato prima di iniziare. Nessuna sorpresa sul conto finale.",
  },
  {
    icon: BadgeCheck,
    title: "Garanzia scritta",
    text: "Ricambi originali e garanzia sull'intervento, sempre documentata.",
  },
];

export default function WhyUs() {
  return (
    <section className="border-y border-line bg-ink/30 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead kicker="Perché noi" title="Perché scegliere RomaTech24" />

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {POINTS.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={0.08 * i} className="h-full">
              <div className="group h-full rounded-3xl border border-line bg-card p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-volt/40">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-volt/30 bg-volt/10 transition-transform duration-500 group-hover:scale-110">
                  <Icon size={21} className="text-volt" strokeWidth={2.1} />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-white">{title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
